import { Component, HostBinding } from '@angular/core';

@Component({
  selector: 'span[app-card-indicators-label]',
  standalone: true,
  template: '<ng-content></ng-content>',
  styleUrls: ['card-indicators-label.component.scss'],
})
export class CardIndicatorsLabelComponent {
  @HostBinding('class.card-indicators-label') readonly isCardIndicatorsLabel = true;
}
